import axios from '../../axios';
import * as TYPES from '../types';

const state = {
  contracts: [],
  contractDetail: null,
  contractTypes: [],//合同性质
};
const getters = {
  contracts: state => state.contracts,
  contractDetail: state => state.contractDetail,
  contractTypes: state => state.contractTypes,
};
const mutations = {
  [TYPES.SET_CONTRACTS](state, payload) {
    state.contracts = payload;
  },
  [TYPES.SET_CONTRACT_DETAIL](state, payload) {
    state.contractDetail = payload;
  },
  [TYPES.SET_CONTRACT_TYPES](state, payload) {
    state.contractTypes = payload;
  }
};
const actions = {

  /**
   * 获取合同列表
   * @param commit
   * @param ts
   * @param params
   */
  getContracts: ({commit}, {ts, params}) => {
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/contracts" + ts, {params: {...params,sort:'createDate,desc'}})
      .then(response => {
        commit(TYPES.SET_CONTRACTS, response.data.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 获取合同详情
   * @param commit
   * @param contractId
   */
  getContractDetail: ({commit}, contractId) => {
    commit(TYPES.SET_CONTRACT_DETAIL, null);
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/contracts/" + contractId)
      .then(response => {
        commit(TYPES.SET_CONTRACT_DETAIL, response.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 获取合同类型
   * @param commit
   */
  getContractTypes: ({commit}) => {
    axios
      .get("/lookups/contract/types")
      .then(response => {
        commit(TYPES.SET_CONTRACT_TYPES, response.data);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}